import { WalletViewModel } from '@apis/model/wallet/WalletViewModel';
import { toOtpViewModel } from '@apis/responseTransformer';
import { WalletResponse } from '@ul/api';

export const toWalletViewModel = (walletResponse: WalletResponse): WalletViewModel => {
    const { success, responseCode, downStreamServiceFailure, token, windowsDurationSec, passkey } = walletResponse;
    return {
        responseCode,
        success,
        downStreamServiceFailure,
        token,
        otpViewModel: toOtpViewModel(walletResponse),
        windowsDurationSec,
        passkey,
    };
};
